import { useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";

import CountryTable from "./components/CountryTable";
import SimpleModal from "../../components/common/SimpleModal";
import CountryForm from "./components/form/CountryForm";
import { setIsEditCountry } from "./redux/countrySlice";
import AddIcon from "../../components/common/AddIcon";
import { useCountryQuery } from "../../graphql/apollo/query-hooks";

const Country = () => {
  const dispatch = useDispatch();
  const { getCountryList } = useCountryQuery();

  const [showModal, setShowModal] = useState(false);
  const handleCloseModal = () => setShowModal(false);
  const handleAdd = () => {
    dispatch(setIsEditCountry(false));
    setShowModal(true);
  };

  return (
    <>
      <SimpleModal
        show={showModal}
        handleClose={handleCloseModal}
        title="ເພີ່ມປະເທດ"
        size="md"
      >
        <CountryForm handleClose={handleCloseModal} />
      </SimpleModal>
      <Row className="lao">
        <Col lg={12}>
          <Card>
            <Card.Header>
              <Card.Title>
                <h3 className="p-1">ຈັດການຂໍ້ມູນປະເທດ</h3>
              </Card.Title>
              <AddIcon onClick={handleAdd} />
            </Card.Header>
            <Card.Body>
              <CountryTable data={getCountryList} />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default Country;
